import './App.css';
import "bootstrap/dist/css/bootstrap.min.css"
import MyNavBar from './components/Navigation/MyNavBar';
import Header from './components/Header';

function App() {
  return (
    <>
      <MyNavBar />
      <Header />
    </>
  );
}

export default App;
